import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { useBlockPackingMutation, useDeletePackingListMutation } from "../../services/Api";


// Async thunks
export const blockPackingThunk = createAsyncThunk(
    "packing/blockPacking",
    async ({ id, duration = "6months" }) => {
        try {
            const [blockPacking] = useBlockPackingMutation();
            await blockPacking({ id, blockDuration: duration });
            toast.success("Packing List Blocked Successfully");
            return id;
        } catch (error) {
            toast.error("Failed to block packing list");
            // return rejectWithValue(error.message);
        }
    }
);

export const deletePackingThunk = createAsyncThunk(
    "packing/deletePacking",
    async (id) => {
        try {
            const [deletePackingList] = useDeletePackingListMutation();
            await deletePackingList({ id });
            toast.success("Packing List Deleted Successfully");
            return id;
        } catch (error) {
            toast.error("Failed to delete packing list");
            // return rejectWithValue(error.message);
        }
    }
);

// Slice
const packingSlice = createSlice({
    name: "packing",
    initialState: {
        items: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(blockPackingThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(blockPackingThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.items = state.items.map((item) =>
                    item.id === action.payload ? { ...item, blocked: true } : item
                );
            })
            .addCase(blockPackingThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deletePackingThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(deletePackingThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.items = state.items.filter((item) => item.id !== action.payload);
            })
            .addCase(deletePackingThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default packingSlice.reducer;
